import { useEffect } from 'react'
import { Navigate, useParams } from 'react-router'

import { useQuoteHandler } from 'src/store/useQuoteHandler'
import { initAnalytics, resetAnalytics, useQuery } from 'utils'

export const StartQuoteRedirect = () => {
  const { quoteId } = useParams<{ quoteId: string }>()
  const query = useQuery()
  const isDirectLead = query.get('directLead')
  const { updateQuoteGeneralInfo } = useQuoteHandler()

  if (!quoteId) {
    throw new Error('Route does not have a quote ID')
  }

  useEffect(() => {
    // Moving analytics reset & init so we can use feature flags
    resetAnalytics()
    initAnalytics(quoteId, { optedInToProductUpdates: true })

    updateQuoteGeneralInfo(quoteId, {
      directLead: Boolean(isDirectLead),
    })
  }, [])

  const isQuoteCompleted = Boolean(localStorage.getItem(`quote-${quoteId}-completed`))

  if (isQuoteCompleted) {
    return <Navigate replace to={`/quote/${quoteId}/continue-quote`} />
  }

  return (
    <Navigate
      to={isDirectLead ? `/direct/${quoteId}/save-for-later` : `/direct/${quoteId}/registration`}
      replace
    />
  )
}
